import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { SpgWidgetState } from './types';

/*
widgetData:{
quick_home:{
}
}
*/

const initialState: SpgWidgetState = {
  widgetData: {},
};

export const spgWidgetSlice = createSlice({
  name: 'spgWidget',
  initialState,
  reducers: {
    setIsLoading(state, action: PayloadAction<Record<string, any>>) {
      const { widgetCode, data } = action.payload;
      state.widgetData = {
        ...state.widgetData,
        [widgetCode]: { ...state.widgetData[widgetCode], isLoading: data },
      };
    },
    setError(state, action: PayloadAction<Record<string, any>>) {
      const { widgetCode, data } = action.payload;
      state.widgetData = {
        ...state.widgetData,
        [widgetCode]: { ...state.widgetData[widgetCode], error: data },
      };
    },
    setWidgetData(state, action: PayloadAction<Record<string, any>>) {
      const { widgetCode, data } = action.payload;
      state.widgetData = {
        ...state.widgetData,
        [widgetCode]: { ...state.widgetData[widgetCode], data },
      };
    },
    setWidgetState(state, action: PayloadAction<Record<string, any>>) {
      const { widgetCode, data } = action.payload;
      state.widgetData = { ...state.widgetData, [widgetCode]: data };
    },
    // setTileAction
    setSelectedTileData(state, action: PayloadAction<Record<string, any>>) {
      const { widgetCode, data } = action.payload;
      state.widgetData = {
        ...state.widgetData,
        [widgetCode]: {
          ...state.widgetData[widgetCode],
          selectedTileData: data,
        },
      };
    },
    setTileActionLoading(state, action: PayloadAction<Record<string, any>>) {
      const { widgetCode, data } = action.payload;
      state.widgetData = {
        ...state.widgetData,
        [widgetCode]: {
          ...state.widgetData[widgetCode],
          isTileActionLoading: data,
        },
      };
    },
    setTileActionError(state, action: PayloadAction<Record<string, any>>) {
      const { widgetCode, data } = action.payload;
      state.widgetData = {
        ...state.widgetData,
        [widgetCode]: {
          ...state.widgetData[widgetCode],
          tileActionError: data,
        },
      };
    },
  },
});

export const {
  setIsLoading,
  setError,
  setWidgetData,
  setWidgetState,
  setSelectedTileData,
  setTileActionLoading,
  setTileActionError,
} = spgWidgetSlice.actions;

const reducer = { spg: spgWidgetSlice.reducer };

export default reducer;
